import Container from './../dom/Container';
import Label from './../dom/Label';
import Image from './../dom/Image';
import Span from '../dom/Span';
import Icon from '../dom/Icon';
import EpgConstants from './../../../Nepg/EpgConstants';
import Utils from '../../../../utils/Utils';
import { NpvrUtil } from '../../../Npvr/NpvrUtil';
import channelStreamUtil from '../../../../utils/ChannelStreamUtil';
import EpgPersistence from '../../../Nepg/EpgPersistence';
import { Dates } from '../../../../packages/dates';
import ReminderNotifications from '../../../../utils/RemindersNotifications/ReminderNotifications';
import {
    NPRV_SCHEDULED_STATUS,
    NPVR_RECORDING_STATUS,
    NPVR_RECORDED_STATUS
  } from '../../../Npvr/Constans';
import Asset from '../../../../requests/apa/Asset';

export default class GridItem extends Container {

    constructor(elementParent, attrs) {
        super(elementParent, attrs);
        this.data = null;

        this.title = null;
        this.hourTitle = null;
        this.image = null;
        this.width = null;
        this.recordText = null;

        this.cssTitle = 'event-list-item-title';
        this.csshourTitle = 'event-list-item-hourTitle';
        this.cssIconReminder = 'event-list-item-iconReminder';
        this.cssImage = 'event-list-item-image';

        this.cssTitleWithImage = 'event-list-item-title-image';
        this.cssTitleWithoutImage = 'event-list-item-title-no-image';

        this.cssTitleNow = 'event-list-item-title-now';
        this.cssTitleNormal = 'event-list-item-title-window';

        this.cssFocus = 'event-list-item-focus';
        this.cssRecordImage = 'event-list-item-record-image';
        this.cssRecordText = 'event-list-item-record-text';

        this.fx = 1;

        this.animId = null;
        this.style = {};
        this.enableNativeAnim = false;
        this.direction = null;

        this.textAnimId = null;
        this.textHourAnimId = null;
        this.imageReminder = Asset.get('playingLive_programFuture_option_button_reminder', '/images/ic_clock.png');
    }

    setNativeAnimation(enable) {
        this.enableNativeAnim = enable;
    }

    setNavigationDirection(direction) {
        this.direction = direction;
    }

    setStyle(style, direction = null) {
        if (!window.requestAnimationFrame) {
            super.setStyle(style);

            return;
        };

        if (!this.enableNativeAnim) {
            this.style = { ...this.style, ...style };
            super.setStyle(this.style);

            return;
        }

        if (style.left) {
            this.setNavigationDirection(direction);
            // Si la animación no esta disponible
            const startLeft = style.left.replace('px', '');
            style.startStyle = startLeft; 
            const w = style.width.replace('px', '');
            const newLeft = this.direction === 'LEFT' ? parseInt(startLeft) - (parseInt(w) / 2) : parseInt(startLeft) + (parseInt(w) / 2);
            style.left = newLeft + 'px';
            this.style = { ...this.style, ...style };
        }
        else {
            this.style = { ...this.style, ...style };
        }
        super.setStyle(this.style);
    }

    getLeftPos() {
        const leftNumber = this.style.left.replace('px', '');
        return leftNumber;
    }

    getWidthPos() {
        const leftNumber = this.style.width.replace('px', '');
        return leftNumber;
    }

    checkRecordingStatus(status, groupId, parent) {
        this.recordImage = new Image(parent);
        this.recordText = new Span(parent)
        this.recordImage.addClassName(this.cssRecordImage);
        this.recordText.addClassName(this.cssRecordText);
        const imageSrc = NpvrUtil.getRecordingAsset(status);
        const npvrData = channelStreamUtil.get(groupId);
        if (imageSrc.imageSrc !== '' && (npvrData && npvrData.npvr)) {
            this.recordImage.setAttrs({
                src: imageSrc.imageSrc
            });
            if(imageSrc.label && status && (status === NPRV_SCHEDULED_STATUS || status === NPVR_RECORDING_STATUS || status === NPVR_RECORDED_STATUS)){
                this.recordText.setText(imageSrc.label);
            }
        } else {
            this.recordImage.hide();
            this.recordText.hide();
        }

        this.recordImage.setStyle({
            top: `${EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE}px`
        });
        this.recordText.setStyle({
            top: `${EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE}px`
        });
    }

    display() {
        //window.NEPG_ITEMDISPLAY = window.performance.now();
        const itemWidth = this.getWidth();
        let widthText;

        this.title = new Label(this);
        this.hourTitle = new Label(this);

        this.title.addClassName(this.cssTitle);
        this.hourTitle.addClassName(this.cssTitle);
        this.hourTitle.addClassName(this.csshourTitle);
        this.isReminder = false;

        let title = EpgPersistence.getLabelNotAvailable();
        let rangeHour = '';
        if (this.data && (typeof this.data.name === 'string') && !(this.data.name == '' || this.data.name == 'NA')) {
            title = this.data.name;
        }
        this.title.setText(title);
        if (this.data && this.data.date_begin && this.data.date_end && !isNaN(this.data.date_begin) && !isNaN(this.data.date_end)) {
            rangeHour = `${EpgPersistence.needsOffset() ? new Dates().unix(this.data.date_begin).utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm') : new Dates().unix(this.data.date_begin).format('HH:mm')} - ${EpgPersistence.needsOffset() ? new Dates().unix(this.data.date_end).utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm') : new Dates().unix(this.data.date_end).format('HH:mm')}`;
        }
        this.hourTitle.setText(rangeHour);

        if (ReminderNotifications.hasEventReminder(this.data.id)) {
            this.isReminder = true;
        }

        // Cabe imagen y texto?
        // if (this.data.ext_eventimage_name && itemWidth >= (EpgConstants.ITEM_IMAGE_WIDTH + EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE + EpgConstants.ITEM_TEXT_MIN_REQUIRED_WIDTH)) {
        //     this.title.addClassName(this.cssTitleWithImage);
        //     this.hourTitle.addClassName(this.cssTitleWithImage);
        //     this.addClassName(this.cssImage);
        //     this.setStyle({
        //         backgroundImage: 'url(\'' + this.data.ext_eventimage_name + '\')',
        //     });
        //     widthText = itemWidth - EpgConstants.ITEM_IMAGE_WIDTH - EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
        //     this.title.setStyle({ width: widthText + 'px' });
        //     this.hourTitle.setStyle({ width: widthText + 'px' });
        // }
        // else {
        //     this.title.addClassName(this.cssTitleWithoutImage);
        //     this.hourTitle.addClassName(this.cssTitleWithoutImage);
        //     widthText = itemWidth - EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
        //     if (widthText < 1) {
        //         widthText = itemWidth;
        //     }
        //     this.title.setStyle({ width: widthText + 'px' });
        //     this.hourTitle.setStyle({ width: widthText + 'px' });
        // }
        this.title.addClassName(this.cssTitleWithoutImage);
        this.hourTitle.addClassName(this.cssTitleWithoutImage);
        widthText = itemWidth - EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
        if (widthText < 1) {
                widthText = itemWidth;
        }
        this.title.setStyle({ width: widthText + 'px' });
        this.hourTitle.setStyle({ width: widthText + 'px' });
        if (NpvrUtil.recordingIconEnable().enable) {
            this.checkRecordingStatus(this.data.recording_status, this.data.group_id, this.title);
        }
        
        if (this.isReminder && !this.isOnNow()) {
            this.iconReminder = new Image(this.hourTitle, { 'src': this.imageReminder});
            this.iconReminder.addClassName(this.cssIconReminder);
        }
        this.title.addClassName(this.isOnNow() ? this.cssTitleNow : this.cssTitleNormal);
        this.hourTitle.addClassName(this.isOnNow() ? this.cssTitleNow : this.cssTitleNormal);


        this.widthText = widthText;
        this.enableNativeAnim && this.runNativeAnimation();
    }

    display2() {
        const itemWidth = this.getWidth();
        let withImage = false;
        let leftText = 0;
        let widthText;
        // Cabe imagen y texto?
        if (this.data.ext_eventimage_name && itemWidth >= (EpgConstants.ITEM_IMAGE_WIDTH + EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE + EpgConstants.ITEM_TEXT_MIN_REQUIRED_WIDTH)) {
            withImage = true;
            leftText = EpgConstants.ITEM_IMAGE_WIDTH + EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
            widthText = itemWidth - EpgConstants.ITEM_IMAGE_WIDTH - EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
        }
        else {
            // Puro texto
            leftText = EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
            widthText = itemWidth - EpgConstants.ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE;
            if (widthText < 1) {
                widthText = itemWidth;
            }
        }

        if (withImage) {
            this.setStyle({
                backgroundImage: 'url(\'' + this.data.ext_eventimage_name + '\')',
                backgroundSize: EpgConstants.ITEM_IMAGE_WIDTH + 'px 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '0px'
            });
        }
        this.title = new Label(this);
        this.title.addClassName(this.cssTitle);
        let title = EpgPersistence.getLabelNotAvailable();
        if (this.data && (typeof this.data.name === 'string') && !(this.data.name == '' || this.data.name == 'NA')) {
            title = this.data.name;
        }
        this.title.setText(title);
        this.title.addClassName(this.isOnNow() ? this.cssTitleNow : this.cssTitleNormal);
        this.title.setStyle({
            left: leftText + 'px',
            width: widthText + 'px'
        });
    }

    setWidth(w) {
        this.width = w;
    }

    getWidth() {
        return this.width;
    }

    isOnNow() {
        if (this.data && this.data.date_begin && this.data.date_end) {
            //let justNow = Date.now() / 1000;
            let justNow = Utils.nowAsTimestampSeconds();
            return (this.data.date_begin <= justNow && this.data.date_end > justNow);
        }

        return false;
    }

    /**
     * 
     * @param {*} data la data del evento
     */
    setData(data) {
        this.data = data;
    }

    getData(data) {
        return this.data;
    }

    hightlightOn() {
        this.addClassName(this.cssFocus);

        if(Utils.playerEnableAnimation()) {
            if (this.fx === 1) {
                this.title.rootElement.style.borderRight = 'none';
                this.hourTitle.rootElement.style.borderRight = 'none';
                
                this.animateCellWhenFocus(this.title, true, true);
                this.animateCellWhenFocus(this.hourTitle, true, false);
            }
            else {
                this.animateParentCellWhenFocus(this.title.rootElement.parentNode);
            }
        }
    }

    hightlightOff() {
        this.removeClassName(this.cssFocus);

        if(Utils.playerEnableAnimation()) {
            if (this.fx === 1) {
                if(this.textAnimId) {
                    window.cancelAnimationFrame(this.textAnimId);
                    this.textAnimId = null;
                }

                if(this.textHourAnimId) {
                    window.cancelAnimationFrame(this.textHourAnimId);
                    this.textHourAnimId = null;
                }
                this.title.getRootElement().style.transform =  'translateX(0)';
                this.hourTitle.getRootElement().style.transform =  'translateX(0)';
                this.title.rootElement.style.borderRight = '1px solid #53535d';
                this.hourTitle.rootElement.style.borderRight = '1px solid #53535d';
            }
            else {
                this.animateParentCellWhenUnFocus(this.title.rootElement.parentNode);
            }
        }
    }

    /**
     * 
     * @param {*} elemen 
     * @param {*} right 
     * 
     * `Math.min()` is used here to make sure that the element stops at exactly 200px.
     * Stop the animation after 2 seconds
     */
    animateCellWhenFocus(elemen, right = true, isTitle = true) {
        let start = null;

        const currentAnimId = isTitle ? this.textAnimId : this.textHourAnimId;
        if(currentAnimId) {
            window.cancelAnimationFrame(currentAnimId);
            if(isTitle) this.textAnimId = null;
            if(!isTitle) this.textHourAnimId = null;
        }

        const byStep = (timestamp) => {
            if (start === null) {
                start = timestamp;
            }
            const elapsed = timestamp - start;
            let stepX = Math.min(0.1 * elapsed, 10);
            if (!right) {
                stepX = stepX * -1;
            }
            elemen.rootElement.style.transform = 'translateX(' + stepX + 'px)';

            let stepScale = Math.min(0.1 * elapsed, 1);
            // this.rootElement.style.transform = `scale(${stepScale}, ${stepScale})`;

            if (elapsed < 100) {
                if(isTitle) this.textAnimId = window.requestAnimationFrame(byStep);
                if(!isTitle) this.textHourAnimId = window.requestAnimationFrame(byStep); 
            }
        }
        
        if(isTitle) this.textAnimId = window.requestAnimationFrame(byStep);
        if(!isTitle) this.textHourAnimId = window.requestAnimationFrame(byStep); 
    }

    animateParentCellWhenFocus(elemen) {
        let start = null;
        let scale = 1.01;
        const byStep = (timestamp) => {
            if (start === null) {
                start = timestamp;
            }
            const elapsed = timestamp - start;

            scale += .002;
            scale = Math.min(scale, 1.01);

            elemen.style.transform = 'scale(' + scale + ')';
            if (elapsed < 200) {
                window.requestAnimationFrame(byStep);
            }
        }
        window.requestAnimationFrame(byStep);
    }

    animateParentCellWhenUnFocus(elemen) {
        let start = null;
        let scale = 1.01;
        const byStep = (timestamp) => {
            if (start === null) {
                start = timestamp;
            }
            const elapsed = timestamp - start;

            scale -= .002;
            scale = Math.max(scale, 1.0);

            elemen.style.transform = 'scale(' + scale + ')';
            if (elapsed < 200) {
                window.requestAnimationFrame(byStep);
            }
        }
        window.requestAnimationFrame(byStep);
    }

    /**
     * Animación al navegar en las celdas
     */
    runNativeAnimation() {
        if (!window.requestAnimationFrame) return;

        const elemen = this.getRootElement();

        if (this.animId) {
            window.cancelAnimationFrame(this.animId);
            this.animId = null;
        }

        let start = null;
        const byStep = (timestamp) => {
            if (start === null) {
                start = 0;
            }
            start += 30;
            const stepX = this.direction === 'LEFT' ? start : start * -1;
            elemen.style.transform = 'translateX(' + stepX + 'px)';

            const limitA = this.getWidthPos() / 2;
            if (start < limitA) {
                this.animId = window.requestAnimationFrame(byStep);
            } else {
                elemen.style.transition = 'transform 0.2s';
                const finalStep = this.direction === 'LEFT' ? limitA : limitA * -1;
                elemen.style.transform = 'translateX(' + finalStep + 'px)';
            }
        }
        this.animId = window.requestAnimationFrame(byStep);
    }

    destroy() {
        if (this.animId) {
            window.cancelAnimationFrame && window.cancelAnimationFrame(this.animId);
        }
        super.destroy();
    }
}



// WEBPACK FOOTER //
// ./src/AAF/lib/gui/components/GridItem.js